import { join, compact } from 'lodash';
import { getPreferredProp } from "../../utils";
function stringifyAddress() {
  let address = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const getValue = fieldName => {
    const field = address[fieldName] || {};
    return getPreferredProp(field, 'value') || '';
  };
  const parts = [getValue('line_1'), getValue('city'), `${getValue('state')} ${getValue('postal_code')}`.trim()];
  return join(compact(parts), ', ');
}
export default stringifyAddress;
//# sourceMappingURL=stringifyAddress.js.map